import React from 'react';

const InsightsSection: React.FC = () => {
  return (
    <section className="max-w-[760px] mx-auto px-6 py-8 space-y-5 font-['Montserrat']">
      <article className="relative bg-[#f3f4f6] rounded-[8px] border border-[#d4d9e1] shadow-[0_1px_3px_rgba(15,23,42,0.08)] px-6 md:px-8 pt-16 md:pt-14 pb-6 md:pb-7">
        <div className="absolute top-[10px] md:top-[12px] -left-[8px] md:-left-[10px] w-[calc(100%+16px)] md:w-auto">
          <div className="w-full md:w-auto bg-[#0B6054] text-white px-10 py-2 text-[18px] md:text-[22px] leading-[1] tracking-[0.01em] font-[700] rounded-tl-[2px] rounded-br-[1px] text-center md:text-left">
            The Brutal Truth About 2025
          </div>
          <span className="absolute left-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform rotate-90" />
          <span className="absolute right-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform md:hidden" />
        </div>

        <div className="text-[14px] md:text-[16px] leading-[1.3] md:leading-[1.32] tracking-[0.01em] space-y-4 text-[#000000] mt-5 font-[500]">
          <p>Most people missed it.</p>
          <p>The mining sector didn't "recover."</p>
          <p>It detonated.</p>
          <p>
          Gold & silver miners exploded because three unstoppable forces collided at once — and every single one of them is still building momentum heading into 2026:
          </p>
          <ul className="list-disc pl-6 md:pl-8 space-y-3">
            <li>$38 trillion in U.S. debt exploding faster than GDP → global flight from the dollar → gold reclaiming its throne as the ultimate reserve asset</li>
            <li>AI data centers creating the biggest power & electrification crisis in history → structural, multi-decade demand shock for copper, silver, uranium</li>
            <li>China weaponizing rare earths → U.S. & allies racing for secure supply → massive selective upside for the right juniors</li>
          </ul>
          <p>This isn't hype.</p>
          <p>
          This is the exact macro setup that turned AbraSilver from a $5 million struggling name into a $2 billion+ silver powerhouse when I first flagged it in 2018.
          </p>
          <p>And the rocket still has fuel.</p>
        </div>
      </article>

      <article className="relative bg-[#f3f4f6] rounded-[8px] border border-[#d4d9e1] shadow-[0_1px_3px_rgba(15,23,42,0.08)] px-6 md:px-8 pt-16 md:pt-14 pb-6 md:pb-7">
        <div className="absolute top-[10px] md:top-[12px] -left-[8px] md:-left-[10px] w-[calc(100%+16px)] md:w-auto">
          <div className="w-full md:w-auto bg-[#1A2A44] text-white px-10 py-2 text-[18px] md:text-[22px] leading-[1] tracking-[0.01em] font-[700] rounded-tl-[2px] rounded-br-[1px] text-center md:text-left">
            What the Full Report Delivers <span className="font-[400]">(Instant Download)</span>
          </div>
          <span className="absolute left-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform rotate-90" />
          <span className="absolute right-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform md:hidden" />
        </div>
        <p className='text-[14px] md:text-[16px] leading-[1.3] md:leading-[1.32] tracking-[0.01em] space-y-4 text-[#000000] mt-5 font-[500]'>Opt in now and you’ll get the complete 2025 Recap & 2026 Strategic Outlook PDF — the same caliber of insight The Wealthy Miner members use to stay positioned ahead of the crowd:</p>
        <ul className="text-[14px] md:text-[16px] leading-[1.3] md:leading-[1.32] tracking-[0.01em] space-y-4 text-[#000000] mt-5 font-[500] list-disc pl-6 md:pl-8">
          <li>
            <strong className="font-[600]">Exact performance numbers:</strong>  Which ETFs, seniors & juniors actually delivered (and which were smoke)
          </li>
          <li>
            <strong className="font-[600]">Macro deep dive with charts:</strong> Debt trajectory, gold/silver ratios, copper supply gap projections, rare earth choke points
          </li>
          <li>
            <strong className="font-[600]">Valuation reality check:</strong>  Why gold producers at ~7× forward EBITDA are still dirt cheap compared to past peaks
          </li>
          <li>
            <strong className="font-[600]">Risk radar:</strong> How to tell a healthy pullback from the start of a real bear phase (bond vigilantes, Fed flip-flops, geopolitics, capital flow warnings)
          </li>
          <li>
            <strong className="font-[600]">2026 positioning playbook:</strong> Where the next explosive leg is most likely — and how to balance big upside with real capital protection
          </li>
          <li>
            <strong className="font-[600]">Hidden accelerator:</strong> Gold-backed stablecoins (currently $4B vs $280B total market) and why even modest adoption could supercharge physical demand
          </li>
        </ul>
      </article>

      <article className="relative bg-[#f3f4f6] rounded-[8px] border border-[#d4d9e1] shadow-[0_1px_3px_rgba(15,23,42,0.08)] px-6 md:px-8 pt-16 md:pt-14 pb-6 md:pb-7 flex flex-col md:flex-row items-start justify-between gap-4 md:gap-5">
        <div className="absolute top-[10px] md:top-[12px] -left-[8px] md:-left-[10px] w-[calc(100%+16px)] md:w-auto">
          <div className="w-full md:w-auto bg-[#D3A12A] text-white px-10 py-2 text-[18px] md:text-[22px] leading-[1] tracking-[0.01em] font-[700] rounded-tl-[2px] rounded-br-[1px] text-center md:text-left">
            Gold Outlook Teaser
          </div>
          <span className="absolute left-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform rotate-90" />
          <span className="absolute right-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform md:hidden" />
        </div>
        <div className="flex-1">
        <ul className="text-[14px] md:text-[16px] leading-[1.3] md:leading-[1.32] tracking-[0.01em] space-y-1 text-[#000000] mt-5 font-[500] list-disc pl-6 md:pl-8">
            <li>Past secular bulls ran 6-7x.</li>
            <li>We are only ~3x off the 2022 lows.</li>
            <li>$10,000/oz is not fantasy — it’s math if history rhymes.</li>
            <li>Silver? Potentially $200+ before reality bites..</li>
          </ul>
        </div>
        <img src="/images/cooper1.webp" alt="Gold nugget" className="self-center md:self-start h-[180px] w-[180px] md:h-[220px] md:w-[220px] object-contain md:-mt-14 -mt-0" />
      </article>

      <article className="relative bg-[#f3f4f6] rounded-[8px] border border-[#d4d9e1] shadow-[0_1px_3px_rgba(15,23,42,0.08)] px-6 md:px-8 pt-16 md:pt-14 pb-6 md:pb-7 flex flex-col md:flex-row items-start justify-between gap-4 md:gap-5">
        <div className="absolute top-[10px] md:top-[12px] -left-[8px] md:-left-[10px] w-[calc(100%+16px)] md:w-auto">
          <div className="w-full md:w-auto bg-[#945E44] text-white px-10 py-2 text-[18px] md:text-[22px] leading-[1] tracking-[0.01em] font-[700] rounded-tl-[2px] rounded-br-[1px] text-center md:text-left">
            Copper Outlook Teaser
          </div>
          <span className="absolute left-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform rotate-90" />
          <span className="absolute right-0 top-full w-0 h-0 border-t-[9px] border-t-[#000000] border-r-[9px] border-r-transparent transform md:hidden" />
        </div>
        <div className="flex-1">
        <ul className="text-[14px] md:text-[16px] leading-[1.3] md:leading-[1.32] tracking-[0.01em] space-y-1 text-[#000000] mt-5 font-[500] list-disc pl-6 md:pl-8">
            <li>AI is not a story, it is a grid-level crisis.</li>
            <li>50%+ demand growth by 2040.</li>
            <li>Multi-million-ton deficits are already locked in.</li>
            <li>Long-life copper names are no longer  miners — they’re infrastructure must-haves.</li>
          </ul>
        </div>
        <img src="/images/cooper2.webp" alt="Copper ore" className="self-center md:self-start h-[180px] w-[180px] md:h-[220px] md:w-[220px] object-contain md:-mt-10 -mt-0" />
      </article>
    </section>
  );
};

export default InsightsSection;
